import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {isMobile} from 'react-device-detect';

var containerStyle = {
    margin: 0,
    bottom: 'auto',
    left: 20,
    top: 20,
    right: 'auto',
    position: 'fixed',
    background: "white",
    paddingTop: "5px"
  };

  var containerStyleMobile = {
    margin: "0 auto",
    bottom: 'auto',
    left: 0,
    top: 0,
    right: 0,
    position: 'fixed',
    background: "white",
    paddingTop: "5px"
  };

  var searchStyle = {
    padding: "5px",
  };


class UserLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authHandler: props.authHandler
        };
    }

    calculateStats = (data) => {
        if (data == null) return {states: null, countries: null};
        var countries =  new Set();
        var states = new Set();
        var birthdays = new Set();
        for(var i = 0; i < data.length; i++) {
            var x = data[i];
            countries.add(x.country.trim());
            if (x.country.trim() === "USA" && x.region.trim().length == 2)
                states.add(x.region.trim());
            if (x.birthday === (new Date().getMonth()+1 + "-" + new Date().getDate()))
                birthdays.add(x.title);
        }
        return {countries: countries.size, states: states.size, nerds: data.length, birthdays: birthdays};
    }

    render() {
        var stats = this.calculateStats(this.props.data);

        return (
            <>
                <Box style={isMobile ? containerStyleMobile : containerStyle} >
                    <Container style={searchStyle} maxWidth="xs">
                        <TextField id="outlined-search" label="Search Usernames" type="search" variant="outlined" onChange={this.props.onSearchChange} size="small"/>
                    </Container>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                            <Typography>Statistics</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>


                            <Table aria-label="simple table">
                                <TableBody>
                                    <TableRow key={"nerds"}>
                                        <TableCell variant={"head"}>Nerds</TableCell>
                                        <TableCell align="right">{stats.nerds}</TableCell>
                                    </TableRow>
                                    <TableRow key={"states"}>
                                        <TableCell variant={"head"}>States</TableCell>
                                        <TableCell align="right">{stats.states}/50</TableCell>
                                    </TableRow>
                                    <TableRow key={"country"}>
                                        <TableCell variant={"head"}>Countries</TableCell>
                                        <TableCell align="right">{stats.countries}</TableCell>
                                    </TableRow>
                                    <TableRow key={"birthday"}>
                                        <TableCell variant={"head"}>Birthdays</TableCell>
                                        <TableCell align="right" dangerouslySetInnerHTML={{__html: Array.from(stats.birthdays).join('</br>')}}></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Box>
            </>
        );
    }

}
export default UserLayout;


